import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { Button } from './Button';
import { FC, ReactNode } from 'react';

interface IConfirmModalProps {
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: FC<IConfirmModalProps> = ({
  title,
  message,
  confirmText = '삭제',
  cancelText = '취소',
  onConfirm,
  onCancel,
}) => {
  const modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    throw new Error('Modal root element not found');
  }

  return createPortal(
    <div
      className={classNames('ds-modal-overlay is-show')}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }}
    >
      <div className="ds-modal ds-modal-alert" role="alertdialog">
        <div className="alert-content">
          <h2 className="alert-title">{title}</h2>
          <p className="alert-message">{message}</p>
        </div>
        <div className="alert-footer">
          <Button theme={'outline'} onClick={onCancel}>
            {cancelText}
          </Button>
          <Button theme={'primary'} onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>,
    modalRoot,
  );
};
